import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { CanteenCard } from '@/entities/canteen'
import { Offcanvas } from '@/entities/offcanvas'
import { useCanteenItem } from '@/shared/api/canteen'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute(
  '/_auth/administration/reference-books/canteens/list/$canteenId'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()
  const { canteenId } = Route.useParams()
  const {
    data: canteen,
    isLoading,
    isError,
  } = useCanteenItem({
    id: canteenId,
    enabled: !!canteenId,
  })

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка столовой')}>
      <CanteenCard canteen={canteen} isLoading={isLoading} isError={isError} />
    </Offcanvas>
  )
}
